<template>
	<v-row no-gutters v-if="testResponse" :class="{ mdA: $vuetify.breakpoint.mdAndDown }">
		<v-col cols="12" class="px-3 text-left mt-3">
			<div class="data_recieved">
				<div class="top-section text-align-center" v-if="isTestError">
					<div class="modal-title">Uh oh, Seems like there was an error.</div>
					<div class="sub-title">See message below. If you need help troubleshooting,</div>
					<div class="sub-title">drop us a line <a class="link-style" href="https://go.ply.io/contact" target="_blank">here</a></div>
				</div>
				<div class="top-section text-align-left" v-else>
					<div class="modal-title">Data received</div>
					<div class="sub-title">You'll be able to use this as sample data in the next steps</div>
				</div>

				<div class="data_wrp text-center">
					<!-- <perfect-scrollbar class="px-4 pt-5 pb-1 data_ps"> -->
					<div class="px-4 pt-5 pb-1 data_ps">
						<v-row no-gutters align="center" v-if="appInfo">
							<v-col class="text-left" cols="auto">
								<v-card class="ac_card integration inline-block">
									<div class="centerdXY">
										<SIcon :name="appInfo.service_slug" :width="12" />
									</div>
								</v-card>
							</v-col>
							<v-col class="pl-3 text-left">
								<h3 class="mt-1 med" style="color: #354052; line-height: 16px !important; font-weight: 600; font-size: 14px">
									{{ appInfo.service_name }}
								</h3>
							</v-col>
						</v-row>
						<DynamicScroller
							v-if="!isTestError"
							:min-item-size="20"
							:items="truncatedTestResponse"
							keyField="key"
							class="scroller-container"
						>
							<template v-slot:default="{ item, index, active }">
								<DynamicScrollerItem class="pt-0 pl-2" :item="item" :active="active" :data-index="index">
									<DataTableRepresentation
										class="pl-1"
										:noun="itemNoun"
										:listKey="item.key"
										:input="item.value"
										:nodeUUID="node.uuid"
										:tableItemOutputLabels="testResultOutputLabels[item.key]"
										v-if="isTable(item.value)"
									></DataTableRepresentation>
									<div v-else class="par_val testResultItem" style="font-size: 14px; font-weight: 300; max-height: 20px line-height: 20px;">
										<span></span>
										<div style="color: #444e5f; font-size: 400; display: inline-block">{{ getReadableKey(item) }}</div>
										<div class="gr pl-2 keyValue">
											{{ item.value }}
										</div>
									</div>
								</DynamicScrollerItem>
							</template>
						</DynamicScroller>
						<div class="errorDetails" v-else>
							{{ testResponse }}
						</div>
					</div>
					<IconButton v-if="showExpand" class="expand-btn" small @click="openInfoDialog"><ExpandSvg /></IconButton>
				</div>
			</div>
			<div class="buttons-section flex-centerize flex-column">
				<OutlinedButton v-if="!hideTestBtn" @click="testAgain" :loading="testBtnLoading">Test Again</OutlinedButton>
				<SecondaryButton v-if="isTestError && hasEditPermissions" @click="$emit('update:showTestResultModal', false)">
					Edit Step
				</SecondaryButton>
				<SecondaryButton v-else-if="hasEditPermissions && addNewStepAllowed" @click="createNewNodeAfterCurrent" smallBtn>
					Add a new step
				</SecondaryButton>
			</div>
		</v-col>
	</v-row>
	<v-row v-else no-gutters>
		<v-col cols="12"> problem with testResponse is: {{ testResponse }} null </v-col>
	</v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import ExpandSvg from './assets/ExpandSvg';
import WidgetService from '../../utils/WidgetService';
import * as WorkflowNodeService from '../../utils/workflow-node-service';
import DataTableRepresentation from '@/components/DataTableRepresentation/DataTableRepresentation';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import { getAction, getActionNoun } from '@/store/modules/actions/getters';
import { shouldFormatPropertyKey } from '@/store/modules/auth/getters';
import { createNewNodeAfterCurrent } from '@/store/modules/treeBlocks/actions';
import { getWidget } from '@/store/modules/widgets/getters';
import ParamsService from '@/utils/ParamsService';
import { isArrayOfObjects } from '@/utils/helpers';

const MAX_SIZE_FOR_VALUE = 350;

export default {
	name: 'BlockEditorTestResult',
	components: {
		DataTableRepresentation,
		ExpandSvg,
	},
	props: {
		appInfo: { type: Object },
		testResponse: { type: [Object, Array] }, // deprecated
		testResponseTruncate: { type: Function },
		testResultStatus: { type: String },
		isTestError: { type: Boolean },
		node: { type: Object },
		hideTestBtn: { type: Boolean },
		hasEditPermissions: { type: Boolean },
		addNewStepAllowed: { type: Boolean, default: true },
		testBtnLoading: { type: Boolean },
	},
	computed: {
		...mapGetters([getWidget.fullPath, getAction.fullPath, shouldFormatPropertyKey.fullPath, getActionNoun.fullPath]),
		showExpand() {
			return !!this.testResponse?.results;
		},
		truncatedTestResponse() {
			if (this.testResponseTruncate) {
				return this.testResponseTruncate(this.testResponse);
			}
			const truncatedTestResponse = Object.entries(this.testResponse)
				.filter(([, value]) => !this.isTable(value) && !this.isTestError)
				.map(([key, value]) => this.mapTestResults(key, value));
			const tableValues = Object.entries(this.testResponse)
				.filter(([, value]) => this.isTable(value))
				.map(([key, value]) => this.mapTestResults(key, value, false));
			truncatedTestResponse.push(...tableValues);
			return truncatedTestResponse;
		},
		isWidget() {
			return WorkflowNodeService.isWidget(this.node);
		},
		itemNoun() {
			return this[getActionNoun.fullPath](this.node.action);
		},
		isConsolidateDataBranchStep() {
			return WorkflowNodeService.isConsolidateDataNode(this.node, this[getAction.fullPath]);
		},
		testResultOutputLabels() {
			return WorkflowNodeService.getTestResponseOutputLabels(this.node);
		},
	},
	methods: {
		...mapActions([createNewNodeAfterCurrent.fullPath]),
		testAgain() {
			this.$emit('test-again');
		},
		getReadableKey(item) {
			return ParamsService.formatPropertyKeyToReadable(item.displayKey, this[shouldFormatPropertyKey.fullPath]);
		},
		createNewNodeAfterCurrent(...args) {
			try {
				this[createNewNodeAfterCurrent.fullPath](...args);
			} catch (e) {
				this.$toast.error(e);
				throw e;
			}
		},
		isTable(value) {
			return isArrayOfObjects(value);
		},
		mapTestResults(key, value, truncateValue = true) {
			let displayKey = key;
			let truncatedValue = value;
			if (truncateValue) {
				truncatedValue = (value ?? '').toString(); // value might be null, so we make sure value is defined
				if (truncatedValue.length > MAX_SIZE_FOR_VALUE) {
					truncatedValue = truncatedValue.substr(0, MAX_SIZE_FOR_VALUE) + '...';
				}
			}
			if (this.isWidget && key.includes('values.')) {
				const widget = this[getWidget.fullPath](WorkflowNodeService.getNodeWidgetId(this.node));
				if (widget) {
					displayKey = WidgetService.replaceKeyWithIdentifier(widget, key);
				}
			} else if (this.isConsolidateDataBranchStep) {
				displayKey = WorkflowNodeService.getConsolidateDataParamName(this.node, key);
			} else if (!this.isTable(value) && this.testResultOutputLabels && key in this.testResultOutputLabels) {
				displayKey = WorkflowNodeService.getValueOfTestResponseOutputLabel(this.testResultOutputLabels[key]);
			}
			return { key, displayKey, value: truncatedValue };
		},
		openInfoDialog() {
			const objInfo = this.testResponse.results || [];
			const restResponse = objInfo.reduce(
				(result, currentRowObject) =>
					result +
					Object.keys(currentRowObject).reduce(
						(res, columnName) => `${res}</br><b>${columnName}:</b> ${currentRowObject[columnName]} </br>`,
						'</br></br>'
					),
				''
			);
			AppDialogManagerService.openInfoDialog({ htmlContent: restResponse });
		},
	},
};
</script>

<style scoped lang="scss">
.top-section {
	margin: 0 0 20px 0;
	color: #292829;

	.modal-title {
		font-weight: 600;
		font-size: 18px;
	}
	.sub-title {
		font-size: 14px;
		line-height: 24px;
	}
}

.buttons-section {
	margin: 20px;

	> button:not(:first-child) {
		margin-top: 10px;
	}
	button {
		width: 200px;
		font-size: 14px !important;
	}
}
h1 {
	font-size: 16px !important;
}
.ac_card {
	width: 26px;
	height: 26px;
	border-radius: 6px !important;
}

.data_wrp {
	position: relative;
	min-height: 250px;
	border-radius: 14px;
	border: 1px solid #d6ddeb;
	background: #f7f8fc !important;

	.expand-btn {
		position: absolute;
		top: 10px;
		right: 10px;

		::v-deep {
			svg {
				transform: scale(0.75);
			}
		}
	}
}
.data_ps {
	height: 290px;
	position: relative;
	.scroller {
		height: calc(100% - 28px);
	}
}
.mdA .data_ps {
	height: 200px !important;
}
.testResultItem {
	height: 20px;
	min-height: 20px;
	text-overflow: ellipsis;
	width: 90%;
	text-align: left;
	white-space: nowrap;
	padding: 0 4px;
}
.par_val {
	text-overflow: ellipsis;
}
.keyValue {
	display: inline-block;
	max-width: 250px;
	transform: translate(0px, 2px);
	line-height: 12px;
	word-break: break-word;
	overflow: hidden;
	text-overflow: ellipsis;
	color: rgba(53, 64, 82, 0.3);
}
.scroller-container {
	max-height: 240px;
	overflow-y: auto;
	text-overflow: ellipsis;
}
.errorDetails {
	max-height: 220px;
	overflow: auto;
}
</style>
